import { IconSize } from '@thyme/nashville/src/types/icons'
import { computed, SetupContext } from 'vue'
import { useRouter } from 'vue-router'
import { RespondToTextSubtaskPropsType } from './types'

/**
 *
 * @param props
 * @param context
 */
export function setup(
  props: RespondToTextSubtaskPropsType,
  context: SetupContext
) {
  const router = useRouter()

  const formattedTitle = computed(() => props.subtask.title ?? '')
  /**
   * Navigate to the patient texting page with the communication ID
   */
  async function goToText() {
    await router.push({
      path: `/patient/${props.subtask.memberId}/texting`,
      query: {
        smsCommId: props.subtask.pointerToCommId,
      },
    })

    context.emit('close')
  }

  return {
    IconSize,
    goToText,
    // added computed values
    formattedTitle,
  }
}
